import { IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class HsnRequest {
    @ApiProperty()
    foodTypeId : number;
    @ApiProperty()
    valueAddOneId : number;
    @ApiProperty()
    valueAddTwoId : number;
    @ApiProperty()
    valueAddThreeId : number;
    @ApiProperty()
    valueAddFourId : number;
    @ApiProperty()
    valueAddFiveId : number;
    @ApiProperty()
    productId : number;
}